import { Switch } from "@mui/material";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import { pointsConfig } from "../../../pointsConfig";

function PointsCreateMissionPlatformActions({
  platformActions,
  onPlatformActionsChange,
  data,
  setData,
}) {
  const toggleFeature = (feature) => {
    const featureValue = platformActions.find((item) => item.label === feature);
    if (!featureValue) {
      onPlatformActionsChange([
        ...platformActions,
        { count: 0, label: feature, enabled: true },
      ]);
      return;
    }
    const toggleValue =
      !platformActions.find((item) => item.label === feature)?.enabled || false;
    onPlatformActionsChange(
      platformActions.map((item) =>
        item.label === feature ? { ...item, enabled: toggleValue } : item
      )
    );
  };

  const updateFeatureCount = (feature, count) => {
    onPlatformActionsChange(
      platformActions.map((item) =>
        item.label === feature ? { ...item, count: Number(count) } : item
      )
    );
  };

  const options = [
    {
      title: "All",
      description:
        "This applies to any of the features (login, quote, compare).",
      toggle: () => {
        toggleFeature("ALL");
      },
      noInput: true,
      code: "ALL",
      visible: true,
    },
    {
      title: "Login",
      description: "This applies to only when agencies log in",
      toggle: () => {
        toggleFeature("LOGIN");
      },
      code: "LOGIN",
      visible: !platformActions.find((item) => item.label === "ALL")?.enabled,
    },
    {
      title: "Quote",
      description: "This applies to only when agencies use the quote feature",
      toggle: () => {
        toggleFeature("QUOTE");
      },
      code: "QUOTE",
      visible: !platformActions.find((item) => item.label === "ALL")?.enabled,
    },
    {
      title: "Compare",
      description: "This applies to only when agencies use the compare feature",
      toggle: () => {
        toggleFeature("COMPARE");
      },
      code: "COMPARE",
      visible: !platformActions.find((item) => item.label === "ALL")?.enabled,
    },
  ];

  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <div className="w-ful flex flex-col gap-4 mb-6">
        {options
          .filter((option) => option.visible)
          .map((option, index) => (
            <div className="w-full flex justify-between gap-2" key={index}>
              <div className="flex flex-1 flex-col">
                <span className="font-medium">{option.title}</span>
                <small className="text-[#6D7C94]">{option.description}</small>
              </div>
              {(!option.noInput ||
                platformActions.find((item) => item.label === option.code)
                  ?.enabled) && (
                <input
                  type="number"
                  min={0}
                  value={
                    platformActions.find((item) => item.label === option.code)
                      ?.count || 0
                  }
                  onChange={(e) => {
                    updateFeatureCount(option.code, e.target.value);
                  }}
                  className="w-20 border border-[#DBDBDB] rounded-md px-3 py-1"
                  placeholder="0"
                />
              )}
              <Switch
                checked={
                  platformActions.find((item) => item.label === option.code)
                    ?.enabled || false
                }
                onChange={() => option.toggle()}
              />
            </div>
          ))}
      </div>
      <CommonDropdownInput
        label="Time Frame"
        value={data?.timeFrame}
        onChange={(val) => setData({ ...data, timeFrame: val })}
        options={pointsConfig.timeFrameOptions}
      />
      <CommonFreeTextInput
        value={Number(data?.pointsRewarded).toLocaleString()}
        label="Points Rewarded"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          setData({ ...data, pointsRewarded: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateMissionPlatformActions;
